var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"comment__content",staticStyle:{"overflow-y":"auto"}},[_c('f-comment-item')],1)}
var staticRenderFns = []

export { render, staticRenderFns }